/**
 * Convert a CSS length prop into a CSS value. A plain number becomes pixels;
 * a string is returned unchanged so any CSS unit can be passed.
 */
export function toCssLength(value: string | number): string {
  return typeof value === 'number' ? `${value}px` : value;
}
